// src/utils/curl.js
//
// cURL construction helpers — extracted verbatim from ReplayTool.jsx (WP6,
// launch-signoff-spec.md §8) so buildFindingTicket.js (finding-grade bug
// tickets) can reuse the same cURL emission without importing the whole
// Replay modal component. ReplayTool.jsx now re-imports these; no behavior
// change there.

/**
 * Standard POSIX single-quote escaping: close quote, insert an escaped
 * single quote, reopen quote. (verbatim from ReplayTool.jsx:91)
 */
export function shellSingleQuote(str) {
  return `'${String(str).replace(/'/g, `'\\''`)}'`;
}

/**
 * Like a plain headers-text -> object parse, but preserves order/duplicates
 * for cURL emission (each `-H` flag is positional). (verbatim from
 * ReplayTool.jsx:113)
 */
export function headersTextToObjOrdered(text) {
  const out = [];
  (text || "").split("\n").forEach((line) => {
    const idx = line.indexOf(":");
    if (idx === -1) return;
    const key = line.slice(0, idx).trim();
    const value = line.slice(idx + 1).trim();
    if (key) out.push([key, value]);
  });
  return out;
}

/**
 * Build a `curl ...` one-liner from the given method/url/headersText/bodyText.
 * (verbatim from ReplayTool.jsx:97)
 */
export function buildCurl({ method, url, headersText, bodyText }) {
  const parts = ["curl"];
  const m = (method || "GET").toUpperCase();
  if (m !== "GET") parts.push("-X", shellSingleQuote(m));
  parts.push(shellSingleQuote(url || ""));
  headersTextToObjOrdered(headersText).forEach(([k, v]) => {
    parts.push("-H", shellSingleQuote(`${k}: ${v}`));
  });
  const trimmedBody = (bodyText || "").trim();
  if (trimmedBody) {
    parts.push("--data", shellSingleQuote(trimmedBody));
  }
  return parts.join(" ");
}
